import { lazy } from 'react';
import { createRouteItem } from 'utils/navigation';
import type { RouterType } from 'commons/modules/routers/routes';

const HomeView = lazy(() => import('views/Home'));

const routers: RouterType[] = [
  {
    path: '/',
    component: HomeView,
    exact: true,
    breadcrumbs: {
      routes: [createRouteItem('Home', '/')],
    },
  },
];

export default routers;
